<div class="tool-tip-div">
    <div>
        <fa-icon *ngIf="icon === 'infocircle'" [icon]="icons.infocircle"></fa-icon>
        <fa-icon *ngIf="icon === 'question'" [icon]="icons.question"></fa-icon>
    </div>

    <div *ngIf="type === 'cv'">
        <span [innerHTML]="(toolService.content | async)?.application?.components?.tooltips?.cv | safe : 'html'"> </span>
    </div>

    <div *ngIf="type === 'Proficiency'">
        <span
            >If your medical school education is/was taught in English, then a letter or other document from your school containing that statement will suffice.
            Alternatively, a passing TOEFL, IELTS, USMLE, OET or any other equivalent exam will also be considered. We also accept proof of US, Canadian, or UK
            citizenship. If you do not have any of the above, then you can schedule a quick Zoom meeting here.
            <a href="https://meetings.hubspot.com/amo-advisors/dashboard?email={{ userEmail }}" target="_blank">Schedule a call with a coach</a>
        </span>
    </div>

    <div *ngIf="type === 'rightCardContentTelehealth'">
        <span [innerHTML]="(toolService.content | async)?.application?.components?.tooltips?.rightCardContentTelehealth | safe : 'html'"> </span>
    </div>

    <div *ngIf="type === 'ImmunizationRecords'">
        <span [innerHTML]="(toolService.content | async)?.application?.components?.tooltips?.immunizationRecords | safe : 'html'"> </span>
    </div>

    <div *ngIf="type === 'HealthInsurance'">
        <span [innerHTML]="(toolService.content | async)?.application?.components?.tooltips?.healthInsurance | safe : 'html'"> </span>
    </div>

    <div *ngIf="type === 'MalpractiseInsurance'">
        <span [innerHTML]="(toolService.content | async)?.application?.components?.tooltips?.malpractiseInsurance | safe : 'html'"></span>
    </div>

    <div *ngIf="type === 'Invite'">
        <span [innerHTML]="(toolService.content | async)?.application?.components?.tooltips?.b1VisaInvite | safe : 'html'"></span>
    </div>
</div>
